import React, { useEffect } from "react";
import ViewProject from "../components/viewProject";
import { useDispatch } from "react-redux";
import * as projectAction from "../../../../redux/storm-water/actions/projectAction";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../../../library/common/Loader";
import { PRODUCT_ID } from "../../../../constant/storm-water/constant";
import { ORG_ID } from "../../../../constant/constant";
import * as adminAction from "../../../../redux/actions/adminCommonAction";

const ViewProjectContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const projectId = location?.state?.projectid;
  const getSwProjectDetailData = useSelector(
    (state) => state.getSwProjectDetail
  );
  const division = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.divisons
  );

  const isLoading = useSelector(
    (state) =>
      state.getSwProjectDetail?.isLoading ||
      state.getDropdownDataKeyValue?.isLoading
  );

  const getProjectDetails = (data) => {
    const payload = {
      projectId: data,
    };
    dispatch(projectAction.getProjectDetails(payload));
  };

  const getDropdownDataKeyValueData = {
    orgId: location?.state?.customerId
      ? location?.state?.customerId
      : parseInt(ORG_ID()),
    flags: "6",
    productId: PRODUCT_ID(),
    Clientid: location?.state?.customerId ? location?.state?.customerId : null,
  };

  useEffect(() => {
    if (projectId) {
      getProjectDetails(projectId);
    }
  }, [projectId]);

  useEffect(() => {
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);
  return (
    <>
      {isLoading && <Loader />}
      <ViewProject
        projectData={getSwProjectDetailData?.data?.result}
        locationData={location?.state}
        division={division}
      />
    </>
  );
};

export default ViewProjectContainer;
